import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AppointmentSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [sessionInfo, setSessionInfo] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const clientToken = localStorage.getItem("client_access_token");

  useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get("session_id");

  const finalizeBooking = async () => {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/client/verify-session`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${clientToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_id: sessionId }),
    });

    const result = await res.json();

    console.log("result", result);

    if (result.success && result.payment_status === 'paid') {
      // now create the booking
      console.log("result", result);
      const appointmentPayload = {
        provider_id: result.metadata.provider_id,
        service_id: result.metadata.service_id,
        start_date: result.metadata.start_date,
        start_time: result.metadata.start_time,
        end_time: result.metadata.end_time,
        end_date: result.metadata.end_date,
        type: result.metadata.type,
        hours: result.metadata.hours,
        amount: result.metadata.amount,
        meeting_type: result.metadata.meeting_type,
        stripe_payment_id: result.payment_intent,
        working_dates: result.metadata.working_dates,
        status: 'confirmed',
        // provider_plan_id: result.metadata.provider_plan_id
      };

      const book = await fetch(`${process.env.REACT_APP_BACKEND_URL}/client/book-appointment`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${clientToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(appointmentPayload),
      });

      const bookResult = await book.json();
      console.log("Appointment booked:", bookResult);
       toast.success("Appointment Booked", {
                    position: "top-right",
                    autoClose: 2000,
                    style: { fontSize: "0.85rem" },
                  });
      navigate("/panel/book_appointment");
    }
  };

  if (sessionId) {
    finalizeBooking();
  }
}, []);


  if (loading) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
      <i className="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
      <p className="h5">Verifying your payment...</p>
    </div>
  );
}

  if (error) return <p className="text-danger">{error}</p>;

//   setTimeout(() => {
//   // window.location.href = "/provider/panel/payment";
//   navigate("/panel/book_appointment");
// }, 3000);

  // console.log("session", sessionInfo);

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
            Payment Success
          </h4>
      {sessionInfo ? (
        <>
          <div className="text-center mt-5">
      <i className="fas fa-check-circle fa-3x text-success mb-3"></i>
      <h4>Payment verified successfully!</h4>
      <p>Redirecting to your dashboard...</p>
    </div>
        </>
      ) : (
        <p>No payment details available.</p>
      )}
    </div>
  </div>
  );
};

export default AppointmentSuccess;
